module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/assets/asd.json
// module id = FJok
// module chunks = 5